<script lang="ts" setup>
import { RefugeImage } from '~/types/RefugeImage';

usePageSeo('seoRefugeTitle', 'seoRefugeDescription');

const storyImg = new RefugeImage("https://res.cloudinary.com/dlct0dnwt/image/upload/q_auto:eco/v1743292001/refuge/2025/3PMA7289_iqzgsu.jpg", "Refuge from afar. Summer. Perfect skies.");
const bookingImg = new RefugeImage("https://res.cloudinary.com/dlct0dnwt/image/upload/q_auto:eco/v1684614497/refuge/inside/sleepingArea_1_sdpz17.jpg", "Sleeping area.");
const approachImg = new RefugeImage("https://res.cloudinary.com/dlct0dnwt/image/upload/q_auto:eco/v1684614479/refuge/outside/outside_19_gqhim7.jpg", "Outside the refuge.");
const photosImg = new RefugeImage("https://res.cloudinary.com/dlct0dnwt/image/upload/q_auto:eco/v1743292000/refuge/2025/MV3A5376_up9lcw.jpg", "Two people walking down the mountain.");
const videosImg = new RefugeImage("https://res.cloudinary.com/dlct0dnwt/image/upload/q_auto:eco/v1684614475/refuge/outside/outside_15_v9wdcw.jpg", "View from the refuge, dusk.");
const faqImg = new RefugeImage("https://res.cloudinary.com/dlct0dnwt/image/upload/q_auto:eco/v1684614474/refuge/outside/main_yjac0p.jpg", "The refuge from the approach path.");
const camerasImg = new RefugeImage("https://res.cloudinary.com/dlct0dnwt/image/upload/q_auto:eco/v1743292001/refuge/2025/3PMA7289_iqzgsu.jpg", "Webcams");
</script>

<template>
  <div class="refuge-index-wrapper">
    <Hero
      :title="$t('The Refuge')"
      :subtitle="$t('refugeSubtitle')"
      backgroundImage="https://res.cloudinary.com/dlct0dnwt/image/upload/q_auto:eco/v1743292001/refuge/2025/3PMA7289_iqzgsu.jpg"
    />

    <div class="container">
      <div class="destinations-grid">
        <Destination :refugeImg="storyImg" :text="$t('Our Story')" link="/refuge/story" :cta="$t('ctaReadOurStory')" />
        <Destination :refugeImg="bookingImg" :text="$t('Booking')" link="/refuge/booking" :cta="$t('Book now')" />
        <Destination :refugeImg="approachImg" :text="$t('How to get here')" link="/refuge/approach" :cta="$t('ctaGetDirections')" />
        <Destination :refugeImg="faqImg" :text="$t('faqTitle')" link="/refuge/faq" :cta="$t('ctaReadTheAnswers')" />
        <Destination :refugeImg="photosImg" :text="$t('Photos')" link="/refuge/photos" :cta="$t('ctaSeeThePhotos')" />
        <Destination :refugeImg="videosImg" :text="$t('Videos')" link="/refuge/videos" :cta="$t('ctaWatchTheVideos')" />
        <Destination :refugeImg="camerasImg" :text="$t('webCams')" link="/refuge/cameras" :cta="$t('ctaWatchLive')" />
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.refuge-index-wrapper
  width: 100%
  padding-bottom: 5rem

.container
  max-width: 1200px
  margin: 0 auto
  padding: 0 2rem

.destinations-grid
  display: flex
  flex-wrap: wrap
  gap: 2rem
  justify-content: center

@media (max-width: 640px)
  .destinations-grid
    gap: 1.5rem
  .container
    padding: 0 1.5rem
</style>
